import { reportBuilderChatService } from "../../services/ai.service";
/**
 * G8A AI Agent - which conversation the drawer resumes, per user and REPORT.
 *
 * Conversations are scoped to one report (server-side, in ai_chats), so the
 * "last open chat" is remembered per report too: opening report B never
 * resumes report A's chat. On Add there is no report yet, so the chat is a
 * DRAFT of the client; when that report is first saved, the draft is linked
 * to it (linkDraftToReport) and the Edit page resumes it.
 *
 * Only the id is kept in the browser - a per-viewer convenience. The messages
 * always come from the server, which also refuses a turn sent from the wrong
 * report, so a stale id here can never apply one report's plan to another.
 */
const PREFIX = "createReport.askAi.activeConversation";
/** Storage key for one user's last chat on a report, or on a client's Add page. */
export const activeConversationKey = (userId, reportId, clientId) => `${PREFIX}.${userId || "anon"}.${reportId ? `report.${reportId}` : `draft.${clientId || "none"}`}`;
export const readActiveConversation = (key) => {
    try {
        return localStorage.getItem(key);
    }
    catch {
        return null;
    }
};
export const writeActiveConversation = (key, id) => {
    try {
        if (id)
            localStorage.setItem(key, id);
        else
            localStorage.removeItem(key);
    }
    catch {
        // Storage blocked - the drawer just opens on a new chat next time.
    }
};
/**
 * Called when a report is first saved from Add: the draft chat that built it
 * becomes that report's chat, so the Edit page opens on it. Best effort - a
 * failure only means the Edit page starts a new chat, never a failed save.
 */
export const linkDraftToReport = async (params) => {
    const { userId, clientId, reportId, token } = params;
    const draftKey = activeConversationKey(userId, null, clientId);
    const conversationId = readActiveConversation(draftKey);
    if (!conversationId)
        return;
    try {
        const res = await reportBuilderChatService.link(conversationId, reportId, token);
        if (!res?.data?.success)
            return;
        writeActiveConversation(activeConversationKey(userId, reportId, clientId), conversationId);
        writeActiveConversation(draftKey, null);
    }
    catch {
        // Not linked - it stays a draft of the client.
    }
};
